import { __decorate, __metadata } from "tslib";
import { CompanyAddressItem } from '@common/users/shared';
import { AppRequest } from '@core/shared/app-request';
import { Default, EditorDefinition, Expose, IsBoolean, IsEmail, MinLength, Model, ModelId, Type, ValidateIf, ValidateNested } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
let CompanyOnboardingResponse = /*#__PURE__*/(() => {
  let CompanyOnboardingResponse = class CompanyOnboardingResponse extends Model {};
  CompanyOnboardingResponse = __decorate([ModelId("CompanyOnboardingResponse") // auto-generated by generate-model-ids
  ], CompanyOnboardingResponse);
  return CompanyOnboardingResponse;
})();
export { CompanyOnboardingResponse };
;
let CompanyOnboardingRequest = /*#__PURE__*/(() => {
  let CompanyOnboardingRequest = class CompanyOnboardingRequest extends Model {
    static {
      this.Response = CompanyOnboardingResponse;
    }
  };
  __decorate([Expose(), ValidateNested(), Type(() => CompanyAddressItem), __metadata("design:type", CompanyAddressItem)], CompanyOnboardingRequest.prototype, "companyAddress", void 0);
  __decorate([Expose(), Default(false), IsBoolean(), __metadata("design:type", Boolean)], CompanyOnboardingRequest.prototype, "specifyBillingAddress", void 0);
  __decorate([Expose(), ValidateIf(obj => {
    // console.log('validate?',obj)
    return obj.specifyBillingAddress;
  }), ValidateNested(), Type(() => CompanyAddressItem), __metadata("design:type", CompanyAddressItem)], CompanyOnboardingRequest.prototype, "billingAddress", void 0);
  __decorate([Expose(), MinLength(3), __metadata("design:type", String)], CompanyOnboardingRequest.prototype, "contactName", void 0);
  __decorate([Expose(), IsEmail(), __metadata("design:type", String)], CompanyOnboardingRequest.prototype, "contactEmail", void 0);
  CompanyOnboardingRequest = __decorate([EditorDefinition({
    specifyBillingAddress: true,
    companyAddress: {
      loadDefinition: 'create'
    },
    billingAddress: {
      loadDefinition: 'create'
    },
    contactName: true,
    contactEmail: true
  }), ModelId("CompanyOnboardingRequest") // auto-generated by generate-model-ids
  , AppRequest('manager/users', 'onboarding', {
    httpMethod: AppRequestMethod.POST,
    simpleAbilityCheck: 'MANAGER',
    requiredAccessData: ['company']
  })], CompanyOnboardingRequest);
  return CompanyOnboardingRequest;
})();
export { CompanyOnboardingRequest };